import React from 'react';

const users = {
	xs: (
		<span className="inline-block h-6 w-6 overflow-hidden rounded-full bg-gray-100">
			<svg
				className="h-full w-full text-gray-300"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	),
	sm: (
		<span className="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100">
			<svg
				className="h-full w-full text-gray-300"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	),
	md: (
		<span className="inline-block h-10 w-10 overflow-hidden rounded-full bg-gray-100">
			<svg
				className="h-full w-full text-gray-300"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	),
	lg: (
		<span className="inline-block h-12 w-12 overflow-hidden rounded-full bg-gray-100">
			<svg
				className="h-full w-full text-gray-300"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	),
	xl: (
		<span className="inline-block h-14 w-14 overflow-hidden rounded-full bg-gray-100">
			<svg
				className="h-full w-full text-gray-300"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	),
	xxl: (
		<span className="inline-block h-32 w-32 overflow-hidden rounded-full bg-gray-100">
			<svg
				className="h-full w-full text-gray-300"
				fill="currentColor"
				viewBox="0 0 24 24"
			>
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	),
};

const texts = {
	xs: (text) => (
		<span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-gray-300">
			<span className="text-xs font-medium leading-none text-white truncate">
				{text}
			</span>
		</span>
	),
	sm: (text) => (
		<span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-300">
			<span className="text-sm font-medium leading-none text-white truncate">
				{text}
			</span>
		</span>
	),
	md: (text) => (
		<span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-300">
			<span className="font-medium leading-none text-white truncate">
				{text}
			</span>
		</span>
	),
	lg: (text) => (
		<span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gray-300">
			<span className="text-lg font-medium leading-none text-white truncate">
				{text}
			</span>
		</span>
	),
	xl: (text) => (
		<span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gray-300">
			<span className="text-xl font-medium leading-none text-white truncate">
				{text}
			</span>
		</span>
	),
	xxl: (text) => (
		<span className="inline-flex h-32 w-32 items-center justify-center rounded-full bg-gray-300">
			<span className="text-xl font-medium leading-none text-white truncate">
				{text}
			</span>
		</span>
	),
};

const srcs = {
	xs: (src) => (
		<img className="inline-block h-6 w-6 rounded-full" src={src} alt="" />
	),
	sm: (src) => (
		<img className="inline-block h-8 w-8 rounded-full" src={src} alt="" />
	),
	md: (src) => (
		<img className="inline-block h-10 w-10 rounded-full" src={src} alt="" />
	),
	lg: (src) => (
		<img className="inline-block h-12 w-12 rounded-full" src={src} alt="" />
	),
	xl: (src) => (
		<img className="inline-block h-14 w-14 rounded-full" src={src} alt="" />
	),
	xxl: (src) => (
		<img className="inline-block h-32 w-32 rounded-full" src={src} alt="" />
	),
};

export const AvatarUser = ({ size = 'sm' }) => users[size];
export const AvatarText = ({ size = 'sm', children }) => texts[size](children);
export const AvatarSrc = ({ size = 'sm', src }) => srcs[size](src);

export default AvatarUser;
